export default __webpack_public_path__ + "static/nhs-property-services-d6890bacede6806ca70258fb059d8c1f.png";